import "jquery"
import 'es6-promise/auto'

import moment from "moment";
window.moment = moment;

import axios from "axios";
window.axios = axios;
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

import iziToast from "izitoast";
window.iziToast = iziToast;
iziToast.settings({
    overlay: false,
    class: 'text-dark',
    messageSize: '2em',
    iconSize: '2em',
    iconPosition: 'right',
    timeout: 1500
});

import { createApp, ref } from 'vue'

Array.prototype.pushToBeginning = function (toPush) {
    return this.unshift.apply(this, [toPush]);
}

Array.prototype.random = function () {
    return this[Math.floor((Math.random()*this.length))];
}

Array.prototype.summary = function () {
    return this.reduce((a, b) => a + b, 0);
}

String.prototype.ucfirst = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
}

String.prototype.escapeHtml = function () {
    return this
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

import DipocacoRouter from "./dipocaco/DipocacoRouter"
const router = DipocacoRouter;

import DipocacoStorage from "./dipocaco/DipocacoStorage"
const storage = DipocacoStorage;

import { createI18n } from 'vue-i18n'
import de from "./lang/de";
import en from "./lang/en";

let selectedLanguage = 'en';
if (window.Laravel.auth) {
    selectedLanguage = window.Laravel.auth.userSettings.language;
}

const i18n = createI18n({
    locale: selectedLanguage,
    fallbackLocale: 'en',
    messages: {
        en: en,
        de: de
    }
})

const App = createApp(App)
    .use(router)
    .use(storage)
    .use(i18n)
    .mount('#dipocaco');

import GameSoundService from "./dipocaco/GameSoundService";
window.gameSoundService = new GameSoundService();
